/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRootSelector = exports.getRootSelector = exports.getProgramGuideState = exports.getMetadata = exports.getDataForCoordinate = exports.getAllMetadata = exports.getAllCoordinateDataForId = exports.getAllCoordinateData = void 0;
var DEFAULT_DATA_ID = 'data';
var rootSelector = function rootSelector(state) {
  return state;
};
var setRootSelector = function setRootSelector(selector) {
  rootSelector = selector;
};
exports.setRootSelector = setRootSelector;
var getRootSelector = function getRootSelector() {
  return rootSelector;
};
exports.getRootSelector = getRootSelector;
var getProgramGuideState = function getProgramGuideState(state) {
  return rootSelector(state);
};
exports.getProgramGuideState = getProgramGuideState;
var getAllCoordinateData = function getAllCoordinateData(state) {
  var rootState = rootSelector(state);
  return rootState.coordinateData || {};
};
exports.getAllCoordinateData = getAllCoordinateData;
var getAllCoordinateDataForId = function getAllCoordinateDataForId(state) {
  var dataId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATA_ID;
  return getAllCoordinateData(state)[dataId] || {};
};
exports.getAllCoordinateDataForId = getAllCoordinateDataForId;
var getDataForCoordinate = function getDataForCoordinate(state, coordinate) {
  var x = coordinate.x,
    y = coordinate.y;
  var coordinateData = getAllCoordinateData(state);
  var row = coordinateData[y];
  return row && row[x];
};
exports.getDataForCoordinate = getDataForCoordinate;
var getAllMetadata = function getAllMetadata(state) {
  var rootState = rootSelector(state);
  return rootState.metadata;
};
exports.getAllMetadata = getAllMetadata;
var getMetadata = function getMetadata(state) {
  var dataId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_DATA_ID;
  var allMetadata = getAllMetadata(state);
  return allMetadata ? allMetadata[dataId] : null;
};
exports.getMetadata = getMetadata;